module.exports = __webpack_public_path__ + "static/media/next.7a6b8c00.svg";